import { RouteObject } from 'react-router-dom';
import PrintRule from '@packages/charka-common-ui/page/menu-print-rule/print-rule/print-rule.tsx';
import PrintPageRule from '@packages/charka-common-ui/page/menu-print-rule/print-page-rule/print-page-rule.tsx';
import PrintRuleMenuList from '@packages/charka-common-ui/page/menu-print-rule/print-rule-menu/print-rule-menu-list.tsx';

export const PrintRuleRouter: RouteObject = {
  path: 'print-rule',
  children: [
    {
      path: 'menu',
      children: [
        {
          path: '',
          element: <PrintRuleMenuList />,
        },
        {
          path: ':menuId',
          children: [
            {
              path: '',
              children: [
                {
                  path: '',
                  element: <PrintRule />,
                },
                {
                  path: 'rule/:ruleId',
                  element: <PrintPageRule />,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
